(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popferry-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-popferry-hero]');
    const mobileMQ = window.matchMedia('(max-width: 999px)');

    heroes.forEach((hero) => {
      const slides = hero.querySelectorAll('.popferry-hero__slide');
      if (slides.length < 2) return;

      const interval = parseInt(hero.dataset.autoplay, 10) || 4000;
      let active = 0;
      let timer = null;
      let inView = true;

      const goTo = (next) => {
        slides[active].classList.remove('is-active');
        slides[next].classList.add('is-active');
        active = next;
      };

      const resetToFirst = () => {
        if (active !== 0) goTo(0);
      };

      const tick = () => {
        const next = (active + 1) % slides.length;
        goTo(next);
      };

      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (!mobileMQ.matches) return; // desktop = static, no autoscroll
        if (!inView) return;
        if (document.hidden) return;
        timer = setInterval(tick, interval);
      };

      // Pause when off-screen for performance / battery.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            if (inView) start();
            else stop();
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(hero);

      // Pause when tab is hidden.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      // React to breakpoint crossings.
      const onMQChange = () => {
        if (mobileMQ.matches) {
          start();
        } else {
          stop();
          resetToFirst();
        }
      };
      if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', onMQChange);
      else mobileMQ.addListener(onMQChange);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
